export const fetchNewHashByTaId = async (hash, taId) => {
    const url = window.imaiosRouting.getFosJsRoutingUrlWithSiteaccess(
        "rest_api_anatomy_treeview_convert_hash_to_ta_target",
        {
            hash: encodeURIComponent(hash),
            taId: encodeURIComponent(taId)
        });

    const response = await window.imaios.fetch(url, {
        method: "GET",
        headers: new Headers({ "X-Requested-With": "XMLHttpRequest" }),
    })

    if (response.status >= 400 || response.redirected === true) {
        throw new Error(
            `Not found structure in ta${taId} '${response.status}'`
        );
    }

    if (response.status === 204) {
        throw new Error('No result found');
    }

    if (response.status !== 200) {
        throw new Error(
            `Unexpected response http code '${response.status}' on convert hash for url '${url}'.`
        );
    }

    return await response.json();
}
